export default __webpack_public_path__ + "static/media/howitworks3.3f378aa7.png";